import { render, staticRenderFns } from "./MyButton.vue?vue&type=template&id=3b9f52dc&scoped=true&lang=pug&"
import script from "./MyButton.vue?vue&type=script&lang=ts&"
export * from "./MyButton.vue?vue&type=script&lang=ts&"
import style0 from "./MyButton.vue?vue&type=style&index=0&id=3b9f52dc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9f52dc",
  null
  
)

export default component.exports